module.exports = {"asl.heading":"ASL"}


//////////////////
// WEBPACK FOOTER
// ./src/components/i18n/locales/it.json
// module id = 706
// module chunks = 0